import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { IChartConfig } from './chart-config.interface';
import { IChartDrawer } from './chart-drawer.interface';
import { DonutColorFactory } from './donut-color-factory';

export class SimpleDonutChartWrawer implements IChartDrawer {
  private readonly _totalCount: number;
  private readonly _colorFactory: DonutColorFactory;
  private readonly _data: number[];
  private readonly _percentageData: number[];
  private readonly _strokeColor: string;

  private _chartWidth = 500;

  private _chartHeight = 350;

  private _minChartHeight = 270;

  private _stroke: number;

  private _ox: number;

  private _oy: number;

  private _radius: number;

  private _filled = 0;

  constructor(chartConfig: IChartConfig, private readonly domSanitizer: DomSanitizer) {
    this._data = chartConfig.donutData;

    this._minChartHeight = chartConfig.width / 2 + 20; // we take the width because it's donut chart

    this._colorFactory = (chartConfig.colorFactory as DonutColorFactory) || new DonutColorFactory();

    this._strokeColor = chartConfig.strokeColor || '';

    this._radius = chartConfig.radius || 100;

    this._stroke = chartConfig.stroke || 60;

    this._totalCount = this._data.reduce((sum, x) => sum + x, 0);

    this._percentageData = this._data.map((fill) => (fill * 100) / this._totalCount);

    this._ox = this._chartWidth / 2;

    this._oy = this._chartHeight / 2;
  }

  public get(): SafeHtml {
    let sb = '';

    sb += `<svg viewBox="0 0 ${this._chartWidth} ${this._chartHeight}" width="100%" height="100%"
    style="min-height: ${this._minChartHeight}px">`;

    sb += '<g>';

    sb += this.getSegments();

    sb += '</g>';

    sb += '</svg>';

    return this.domSanitizer.bypassSecurityTrustHtml(sb);
  }

  public getSegments() {
    let sb = '';
    const itemsLength = this._percentageData.length;

    this._percentageData.forEach((segment, index) => {
      const startAngle = -90,
        dashArray = 2 * Math.PI * this._radius,
        dashOffset = dashArray - (dashArray * segment) / 100,
        angle = (this._filled * 360) / 100 + startAngle;
      this._filled += segment;

      sb += `<circle
                cx="${this._ox}"
                cy="${this._oy}"
                r="${this._radius}"
                ${
                  this._strokeColor
                    ? `stroke="${this._strokeColor}"
                  opacity="${(index + 1) * (1 / itemsLength)}"
                  class="tooltip-item"`
                    : this._colorFactory
                    ? `class="${this._colorFactory.get(index, 0, 0)} tooltip-item"`
                    : ''
                }
                fill="transparent"
                pointer-events="visibleStroke"
                stroke-width="${this._stroke}"
                stroke-dasharray="${dashArray}"
                stroke-dashoffset="${dashOffset}"
                transform="rotate(${angle} ${this._ox} ${this._oy})"></circle>`;
    });

    return sb;
  }

  public getIsOverflowed(): boolean {
    return false;
  }

  public getMinOffset(): number {
    return 0;
  }
}
